import { arcadeApiClient } from '../apiClients'
import useSWR from 'swr'
import { Team } from 'types'

const teamsFetcher = async (endpoint): Promise<{ teams: Team[] }> => {
  return arcadeApiClient.get(endpoint).then(res => res.data)
}

const useTeams = (endpoint = '/multi_platform/teams') => {
  const { data, isValidating, error } = useSWR(endpoint, teamsFetcher)

  return {
    teams: data?.teams as Team[],
    loading: isValidating,
    error,
  }
}
export default useTeams
